import booking from "./booking.component";
import bookingUrls from "./booking.urls";
import BookingTransforms from "./booking.transforms";

const bookingModule = angular
  .module("app.components.booking", [])
  .component("bookingPage", booking)
  .service("BookingTransforms", BookingTransforms)
  .config(bookingUrls);

export default bookingModule;



// WEBPACK FOOTER //
// ./src/pages/booking/booking.module.js